<template>
  <b-row class="text-center">
    <b-col cols="12" md class="d-none d-sm-none d-md-block">
      <div id="homeCarousel" class="carousel slide" data-interval="false" data-ride="carousel">
        <div class="carousel-inner" role="listbox">
          <div class="item active">
            <b-embed type="video" id="homevideo" :poster="videoPoster" controls playsinline>
              <source src="@/static/video/video_comercial_reducido.mp4" type="video/mp4" />
            </b-embed>
          </div>
        </div>
      </div>
    </b-col>

    <b-col
      v-if="products.length == 0"
      cols="12"
      md="5"
      class="mt-4 mt-md-0 d-flex flex-column justify-content-between"
    >
      <b-row class="text-center">
        <b-col>
          <b-link :to="{name:'product_list', params: {listType: 'ae'}}">
            <img id="category_ae" :src="getButton('button-home2.png')" />
          </b-link>
        </b-col>
      </b-row>
      <b-row class="text-center">
        <b-col>
          <a href="https://globalpdv.com/" target="_blank">
            <img id="offers" :src="getButton('button-home3.png')" />
          </a>
        </b-col>
      </b-row>
    </b-col>
    <b-col cols="12" md="6" class="mt-0 mt-md-0 d-flex flex-column justify-content-between" v-else>
      <b-row class="text-center">
        <b-col>
          <div>
            <!-- swiper -->
            <vue-element-loading :active="loading_products" />
            <swiper :options="swiperOption" ref="productsBannerSwiper">
              <div
                v-if="products.length == 0"
                class="slider-empty"
              >{{ $t('home_jumbotron.no_results') }}</div>
              <swiper-slide
                v-for="(product, index) in products"
                :key="index"
                class="max-banner-slider-height"
              >
                <ProductBannerCard :product="product" />
              </swiper-slide>
              <div class="swiper-button-prev swiper-button-grey" slot="button-prev"></div>
              <div class="swiper-button-next swiper-button-grey" slot="button-next"></div>
            </swiper>
          </div>
        </b-col>
      </b-row>
      <b-row class="text-center">
        <b-col>
          <b-link :to="{name:'product_list', params: {listType: 'ae'}}">
            <img id="category_ae" :src="getButton('button-home5.jpeg')" />
          </b-link>
        </b-col>
        <b-col>
          <a href="https://blog.globalstorepharma.com/" target="_blank">
            <img id="offers" :src="getButton('button-home4.jpeg')" />
          </a>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import ProductBannerCard from "@/components/ProductBannerCard";
import { mapState } from "vuex";
import { mapGetters } from "vuex";

export default {
  components: {
    ProductBannerCard,
  },
  data() {
    return {
      videoPoster: require("!url-loader!@/static/video/logo_medika.svg"),
      loading_products: false,
      products: [],
      per_page: 8,
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: {
          delay: 5000,
        },
        breakpointsInverse: true,
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 1,
            spaceBetween: 2,
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          667: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          // when window width is >= 640px
          768: {
            slidesPerView: 1,
            spaceBetween: 30,
          },
          1000: {
            slidesPerView: 1,
            spaceBetween: 30,
          },
        },
      },
    };
  },
  mounted: function () {
    this.loadProducts();
    this.configVideo();
  },
  computed: {
    ...mapState({
      active_lang: (state) => state.i18nmap.active_lang,
    }),
    ...mapGetters("auth", ["deviceCountry"]),
  },
  methods: {
    getButton(route) {
      try {
        return require("@/static/buttons/" +
          this.active_lang.langtag +
          "/" +
          route);
      } catch (e) {
        return require("@/static/buttons/es-MX/" + route);
      }
    },
    loadProducts() {
      this.loading_products = true;
      this.$store
        .dispatch("drugs/REQUEST_DRUGS_FEATURED", {
          per_page: this.per_page,
          current_page: this.products.length / this.per_page + 1,
        })
        .then(
          (response) => {
            // Aqui va los banners estaticos que se guardan en /static/banner/idioma/nombre
            var static_banner = [];
            // Solo mostramos los banners estáticos en caso de que el país sea Mexico.
            if (this.deviceCountry == "MX") {
              static_banner = [
                {
                  banners: [
                    {
                      langtag: "es_MX",
                      image: require("@/static/banners/es-MX/banner_home_04.png"),
                    },
                    //{langtag: 'en_US', image: require("@/static/banners/en-US/banner_home_04.png")},
                    {
                      langtag: "default",
                      image: require("@/static/banners/es-MX/banner_home_04.png"),
                    },
                  ],
                },
                {
                  banners: [
                    {
                      langtag: "es_MX",
                      image: require("@/static/banners/es-MX/banner_home_05.png"),
                    },
                    //{langtag: 'en_US', image: require("@/static/banners/en-US/banner_home_05.png")},
                    {
                      langtag: "default",
                      image: require("@/static/banners/es-MX/banner_home_05.png"),
                    },
                  ],
                },
                {
                  banners: [
                    {
                      langtag: "es_MX",
                      image: require("@/static/banners/es-MX/banner_home_06.png"),
                    },
                    //{langtag: 'en_US', image: require("@/static/banners/en-US/banner_home_06.png")},
                    {
                      langtag: "default",
                      image: require("@/static/banners/es-MX/banner_home_06.png"),
                    },
                  ],
                },
                {
                  productRoute: {
                    name: "product_list",
                    params: { listType: "topae" },
                  },
                  banners: [
                    {
                      langtag: "es_MX",
                      image: require("@/static/banners/es-MX/banner_home_07.png"),
                    },
                    //{langtag: 'en_US', image: require("@/static/banners/en-US/banner_home_07.png")},
                    {
                      langtag: "default",
                      image: require("@/static/banners/es-MX/banner_home_07.png"),
                    },
                  ],
                },
                {
                  productRoute: { name: "offers" },
                  banners: [
                    {
                      langtag: "es_MX",
                      image: require("@/static/banners/es-MX/banner_home_08.png"),
                    },
                    //{langtag: 'en_US', image: require("@/static/banners/en-US/banner_home_08.png")},
                    {
                      langtag: "default",
                      image: require("@/static/banners/es-MX/banner_home_08.png"),
                    },
                  ],
                },
              ];
            }

            this.products = this.products.concat(
              static_banner,
              response.data.results
            );
            this.loading_products = false;
          },
          (err) => {
            this.loading_products = false;
            this.$sentry({ capture: err });
          }
        );
    },
    configVideo() {
      const video = document.querySelector("#homevideo");

      // this allows to show poster again
      // but we have to be careful with the autoplay
      video.addEventListener("ended", () => {
        video.load();
      });
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        home_jumbotron: {
          see_all: "See all",
          no_results: "No results found",
          error: {
            load_products: "Cannot load products into the slider",
          },
        },
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.video_end_image {
  max-height: 377px; // This will avoid a weird jump at the video end
}

.swiper-title {
  text-transform: uppercase;
  text-align: center;

  .strike > span {
    display: inline;
    font-size: 1.8rem;
    padding: 0 30px;
  }

  .strike > span::before,
  .strike > span::after {
    background-color: $corp-color2;
  }

  .link a {
    display: block;
    font-size: 1rem;
    text-decoration: none;
  }
}

.swiper-container {
  margin-top: 0rem;
}

.slider-empty {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.swiper-slide {
  display: flex;
  justify-content: center;
}

@media (min-width: 768px) {
  .max-banner-slider-height {
    max-height: calc(100vw / 6);
  }
}
#category_ae {
  max-width: 100%;
}

#offers {
  max-width: 100%;
}

.swiper-button-next,
.swiper-button-prev {
  height: 12%;
  margin-top: -4%;
}

.swiper-button-prev.swiper-button-grey,
.swiper-container-rtl .swiper-button-next.swiper-button-grey {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23cdcdcd'%2F%3E%3C%2Fsvg%3E");
}
.swiper-button-next.swiper-button-grey,
.swiper-container-rtl .swiper-button-prev.swiper-button-grey {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23cdcdcd'%2F%3E%3C%2Fsvg%3E");
}
</style>
